<template>
    <div></div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { mapState, mapActions } from 'vuex'
    import Translations from '@/store/translations';
    export default {
        name: 'TrackActions',
        computed: {
            Translations: () => Translations,
            ...mapState(["currentTrack", "isLoadingTrack"]),
        },
    }
</script>